"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file common.proto (package common, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamResponse = exports.Pos2 = exports.Pos3 = exports.GenericResponse = exports.PlayerIdentifier = exports.PlayerInformation = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message common.PlayerInformation
 */
class PlayerInformation extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uuid = 1;
         */
        this.uuid = "";
        /**
         * @generated from field: string username = 2;
         */
        this.username = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlayerInformation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlayerInformation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlayerInformation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PlayerInformation, a, b);
    }
}
PlayerInformation.runtime = protobuf_1.proto3;
PlayerInformation.typeName = "common.PlayerInformation";
PlayerInformation.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.PlayerInformation = PlayerInformation;
/**
 * @generated from message common.PlayerIdentifier
 */
class PlayerIdentifier extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlayerIdentifier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlayerIdentifier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlayerIdentifier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PlayerIdentifier, a, b);
    }
}
PlayerIdentifier.runtime = protobuf_1.proto3;
PlayerIdentifier.typeName = "common.PlayerIdentifier";
PlayerIdentifier.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.PlayerIdentifier = PlayerIdentifier;
/**
 * @generated from message common.GenericResponse
 */
class GenericResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool success = 1;
         */
        this.success = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GenericResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenericResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenericResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(GenericResponse, a, b);
    }
}
GenericResponse.runtime = protobuf_1.proto3;
GenericResponse.typeName = "common.GenericResponse";
GenericResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
exports.GenericResponse = GenericResponse;
/**
 * @generated from message common.Pos3
 */
class Pos3 extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: double x = 1;
         */
        this.x = 0;
        /**
         * @generated from field: double y = 2;
         */
        this.y = 0;
        /**
         * @generated from field: double z = 3;
         */
        this.z = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Pos3().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Pos3().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Pos3().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Pos3, a, b);
    }
}
Pos3.runtime = protobuf_1.proto3;
Pos3.typeName = "common.Pos3";
Pos3.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "x", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "y", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "z", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
exports.Pos3 = Pos3;
/**
 * 2D position on the XZ plane (Y is handled separately when needed)
 *
 * @generated from message common.Pos2
 */
class Pos2 extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: double x = 1;
         */
        this.x = 0;
        /**
         * @generated from field: double z = 2;
         */
        this.z = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Pos2().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Pos2().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Pos2().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Pos2, a, b);
    }
}
Pos2.runtime = protobuf_1.proto3;
Pos2.typeName = "common.Pos2";
Pos2.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "x", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "z", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
exports.Pos2 = Pos2;
/**
 * @generated from message common.StreamResponse
 */
class StreamResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string eventId = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(StreamResponse, a, b);
    }
}
StreamResponse.runtime = protobuf_1.proto3;
StreamResponse.typeName = "common.StreamResponse";
StreamResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "eventId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
exports.StreamResponse = StreamResponse;
